import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Wand2 } from "lucide-react";
import UniversalQuickAdd from "@/components/UniversalQuickAdd";

/**
 * Mobile-only floating Quick Add button. Positioned to the LEFT of the
 * AssistantWidget FAB so neither overlaps the bottom nav.
 */
export default function QuickAddFAB() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  if (loc.pathname === "/login") return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="md:hidden fixed bottom-[calc(72px+env(safe-area-inset-bottom))] right-[68px] w-12 h-12 rounded-full bg-[#151A23] text-white shadow-2xl border border-white/15 hover:bg-[#1E2532] flex items-center justify-center transition-transform hover:scale-105 z-40"
        data-testid="quick-add-fab"
        title="Quick Add"
        aria-label="Open Quick Add"
      >
        <Wand2 className="w-4 h-4" />
      </button>
      <UniversalQuickAdd open={open} setOpen={setOpen} section="global" onCreated={() => { /* rely on page hot-reload / next visit */ }} />
    </>
  );
}
